import { apiRequest } from '@/utils/api-request';
import { NotificationListResponse } from '@/types/notification-types';
import * as Sentry from '@sentry/react';

interface GetNotificationsParams {
  orgId: string;
  cursor?: string | null;
  limit?: number;
  signal?: AbortSignal;
}

export async function getNotifications({
  orgId,
  cursor,
  limit = 20,
  signal,
}: GetNotificationsParams): Promise<NotificationListResponse> {
  try {
    const params = new URLSearchParams();
    if (cursor) params.set('cursor', cursor);
    params.set('limit', String(limit));

    const response = await apiRequest<NotificationListResponse>({
      url: `/orgs/${orgId}/notifications?${params.toString()}`,
      target: 'notifications',
      method: 'GET',
      signal,
    });

    return response.data ?? { items: [], next_cursor: null, unread_count: 0 };
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'get-notifications', orgId, cursor, limit },
    });
    throw error;
  }
}
